export default __webpack_public_path__ + "static/line-illustration-fb852ce7b505b6b465e16c46251d3cf9.png";